<template>
  <div>
    <form
      @submit.prevent
    >
      <ProgressBar />
      <div class="pvd-container">
        <h1 class="pvd-heading-XXL text-center">
          {{ pd_content.identity_verification_failure_page.identity_verification_failure_title }}
        </h1>
      </div>
      <div class="pvd-container container-divider">
        <p>
          {{ pd_content.identity_verification_failure_page.identity_verification_failure_text }}
        </p>
      </div>
      <div class="pvd-container pvd-btn-row">
        <div class="button-group">
          <button
            class="pvd-btn btn-action"
            @click.prevent="exitLink()"
          >
            {{ pd_content.identity_verification_failure_page.exit_application_btn_txt }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import ProgressBar from '../components/ProgressBar.vue';
import measurement from '../mixins/measurement';
import utility from '../mixins/utility';
import dataHelper from '../mixins/dataHelper';
import constants from '../mixins/constants';

export default {
  name: 'IdentityVerificationFailure',
  components: {
    ProgressBar,
  },
  mixins: [dataHelper, measurement, utility],
  mounted() {
    this.track(this.cs_stateName, 'pageview');
    this.updatePageTitle();
  },
  updated() {
    this.updatePageTitle();
  },
  methods: {
    updatePageTitle() {
      const returnPageTitle = 'Identity verification failed';
      if (returnPageTitle) {
        document.title = this.setTitle(returnPageTitle);
      }
    },
    exitLink() {
      this.track('identity-verification-failure', 'interaction');
      window.location = this.pd_content.identity_verification_failure_page.exit_application_url || constants.OVERVIEW_URL;
    },
  },
};

</script>
